import { useCallback, useState } from 'react'

import { localStorageGet, localStorageRemove, localStorageSet, STORAGE_KEY_PREFIX } from '@taxfix/scouts-helpers'

import { STORAGE_KEY_TAXFIX_ANNOUNCEMENT_MODAL_SEEN, STORAGE_KEY_TAXFIX_ANNOUNCEMENT_MODAL_VISIBLE } from '@/constants'

/**
 * @deprecated Use `useAnnouncementModal` instead
 */
export const useTaxfixAnnouncementModal = () => {
    const [isModalOpen, setIsModalOpen] = useState(
        () => localStorageGet(STORAGE_KEY_TAXFIX_ANNOUNCEMENT_MODAL_VISIBLE, STORAGE_KEY_PREFIX) === 'true'
    )

    const hasSeenTaxfixAnnouncement =
        localStorageGet(STORAGE_KEY_TAXFIX_ANNOUNCEMENT_MODAL_SEEN, STORAGE_KEY_PREFIX) === 'true'

    const openModal = useCallback(() => {
        localStorageSet(STORAGE_KEY_TAXFIX_ANNOUNCEMENT_MODAL_VISIBLE, 'true', STORAGE_KEY_PREFIX)
        setIsModalOpen(true)
    }, [])

    const closeModal = () => {
        localStorageSet(STORAGE_KEY_TAXFIX_ANNOUNCEMENT_MODAL_SEEN, 'true', STORAGE_KEY_PREFIX)
        localStorageRemove(STORAGE_KEY_TAXFIX_ANNOUNCEMENT_MODAL_VISIBLE, STORAGE_KEY_PREFIX)
        setIsModalOpen(false)
    }

    return {
        isTaxfixAnnouncementModalOpen: isModalOpen,
        openTaxfixAnnouncementModal: openModal,
        closeTaxfixAnnouncementModal: closeModal,
        hasSeenTaxfixAnnouncement,
    }
}
